import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.spacing.sp8};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp8};
`
